import axios from 'axios';

import { store } from '../../store';
import config from '../../../config';
import { receiveDataFromOps, setAuthToken } from '../../actions';

const originalURL = window.location.href;
const redirectForLogin = () => {
  const baseUrl = config.networkBaseUrl;
  const path = originalURL.replace(baseUrl, '');
  console.log('path', path);
  if (path) {
    store.dispatch(receiveDataFromOps(path));
  }
  window.location.href = '/';
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const statusCode = error.response ? error.response.data.code : null;
    if (statusCode === 401) {
      store.dispatch(setAuthToken(''));
      return redirectForLogin();
    }

    return Promise.reject(error);
  }
);

const rootUrl = `${config.apiBaseUrl}`;
const baseUrl = `${rootUrl}/network/`;

export default function baseRequest(url, method, params, data) {
  const headers = {};
  const state = store.getState();
  if (state.user.authToken) {
    headers.authorization = state.user.authToken;
  }
  return axios({
    url: `${baseUrl}${url}`,
    method,
    headers,
    params,
    data,
  })
    .then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      throw new Error('Status code is not okk');
    })
    .catch((err) => {
      console.error({ err }, 'Error in endpoint');
      throw err;
    });
}

export function baseRequestWithAxiosResponse(url, method, params, data) {
  const headers = {};
  const state = store.getState();
  if (state.user.authToken) {
    headers.authorization = state.user.authToken;
  }
  return axios({
    url: `${baseUrl}${url}`,
    method,
    headers,
    params,
    data,
  })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.error({ err }, 'Error in endpoint');
      throw err;
    });
}

export function baseRequestOtherBaseUrl(
  url,
  method,
  params,
  data,
  replaceThis,
  withThis
) {
  const headers = {};
  const state = store.getState();
  if (state.user.authToken) {
    headers.authorization = state.user.authToken;
  }
  const newBaseUrl =
    replaceThis && withThis ? baseUrl.replace(replaceThis, withThis) : baseUrl;

  return axios({
    url: `${newBaseUrl}${url}`,
    method,
    headers,
    params,
    data,
  })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.error({ err }, 'Error in endpoint');
      throw err;
    });
}

export function baseRequestWithHeaders(url, method, params, data) {
  const headers = {};
  const state = store.getState();
  if (state.user.authToken) {
    headers.authorization = state.user.authToken;
  }
  return axios({
    url: `${baseUrl}${url}`,
    method,
    headers,
    params,
    data,
  })
    .then((response) => {
      if (response && response.status === 200) {
        return {
          body: response.data,
          headers: response.headers,
        };
      }
      throw new Error('Status code is not okk');
    })
    .catch((err) => {
      console.error({ err }, 'Error in endpoint');
      throw err;
    });
}

export function rootRequestWithHeaders(url, method, params, data) {
  const headers = {};
  const state = store.getState();
  if (state.user.authToken) {
    headers.authorization = state.user.authToken;
  }
  return axios({
    url: `${rootUrl}${url}`,
    method,
    headers,
    params,
    data,
  })
    .then((response) => {
      if (response && response.status === 200) {
        return {
          body: response.data,
          headers: response.headers,
        };
      }
      throw new Error('Status code is not okk');
    })
    .catch((err) => {
      console.error({ err }, 'Error in endpoint');
      throw err;
    });
}

export function checkSuccessfulResponse(response) {
  if (response.message === 'success') {
    return response.data;
  }
  throw new Error('Status Message Not Correct');
}
